import api from './axios';

// Samples API
export const samplesAPI = {
  getAll: (params) => api.get('/samples', { params }),
  getById: (id) => api.get(`/samples/${id}`),
  // Create sample via mobile endpoint (handles team member and admin sample creation)
  create: (formData) => api.post('/mobile/samples', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  // Get water sources and location types for dropdowns
  getSources: () => api.get('/mobile/sources'),
  // Get FIELD parameters for sample creation
  getFieldParameters: () => api.get('/mobile/parameters'),
  // LAB test submission (FIELD_TESTED → LAB_TESTED)
  // remark: Editable remark shown in PDF Remark/Observation section (cannot be empty)
  // testingLocation: On-Site, Laboratory, or Hybrid
  submitLabTest: (id, parameters, remark, testingLocation) => api.post(`/samples/${id}/lab-test`, { parameters, remark, testingLocation }),
  // Publish sample (LAB_TESTED → PUBLISHED)
  publish: (id) => api.patch(`/samples/${id}/publish`),
  archive: (id) => api.patch(`/samples/${id}/archive`),
  delete: (id) => api.patch(`/samples/${id}/archive`), // Soft delete - same as archive
  restore: (id) => api.patch(`/samples/${id}/restore`),
  getStats: () => api.get('/samples/stats'),
  // Get LAB parameters for admin form
  getLabParameters: () => api.get('/parameters', { params: { testLocation: 'LAB' } }),
  // Download PDF report
  downloadPDF: async (id, sampleId) => {
    const response = await api.get(`/samples/${id}/pdf`, { responseType: 'blob' });
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${sampleId || 'sample'}-report.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
};

export default samplesAPI;
